import React from 'react';
import { Badge } from 'components/common';

// Cell renderer for buildings
const BuildingsRenderer = (params) => {
  const {buildings} = params.data;

  if (!buildings || !Array.isArray(buildings) || buildings.length === 0) {
    return <span className="tw-text-slate-500">-</span>;
  }
  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1 tw-text-sm tw-my-2">
      {buildings.map((building, idx) => {
        // Safety check: ensure building has proper structure
        const buildingName = building?.name || (typeof building === 'object' ? JSON.stringify(building) : String(building));
        const buildingId = building?.id || idx;
        return (
          <Badge key={buildingId} variant="info" size="sm">
            {buildingName}
          </Badge>
        );
      })}
    </div>
  );
};

export default BuildingsRenderer;
